module.exports = __webpack_public_path__ + "static/img/solutionText4.70a1c89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText4.png
// module id = M2wx
// module chunks = 1